module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/sections/social_proof/assets/trustpilot_logo-fd6d9d566fb90f55927c0041c2ee826a.svg";